import { supabase } from "../../supabase/supabase";
import { ApiKey } from "@/types/organization";

export const apiKeyService = {
  /**
   * Create a new API key for an organization
   */
  async createApiKey(
    organizationId: string,
    name: string,
  ): Promise<ApiKey | null> {
    try {
      const { data, error } = await supabase.functions.invoke(
        "create_api_key",
        {
          body: { organization_id: organizationId, name },
        },
      );

      if (error) throw error;
      return data;
    } catch (error) {
      console.error("Error creating API key:", error);
      throw error;
    }
  },

  /**
   * Get all API keys for an organization
   */
  async getApiKeys(organizationId: string): Promise<ApiKey[]> {
    try {
      const { data, error } = await supabase
        .from("api_keys")
        .select("*")
        .eq("organization_id", organizationId)
        .order("created_at", { ascending: false });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error("Error fetching API keys:", error);
      return [];
    }
  },

  /**
   * Delete an API key
   */
  async deleteApiKey(keyId: string): Promise<boolean> {
    try {
      const { error } = await supabase
        .from("api_keys")
        .update({ revoked: true, revoked_at: new Date().toISOString() })
        .eq("id", keyId);

      if (error) throw error;
      return true;
    } catch (error) {
      console.error("Error deleting API key:", error);
      return false;
    }
  },
};
